import type { Ref } from 'vue';
import { toRef } from 'vue';

import type { IAppConfigResponse } from '../types';
import { useConfigStore } from '../store';

export interface ConfigComposable {
  config: Ref<IAppConfigResponse | undefined>;
}

export default function useConfig(): ConfigComposable {
  const config = toRef(useConfigStore(), 'config');

  return { config };
}
